import { isEmpty } from 'lodash';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Svg from 'svg-inline-react';
import './styles.scss';

export default function Item({ icon, description, values, suffix }) {
  return (
    <div className="details-item">
      <Svg src={icon} />
      <div className="details-item__content">
        <div className="details-item__description">{description}</div>
        <div className="details-item__values">
          {values.map((value, i) => (
            <Fragment key={i}>
              {i !== 0 && ' or '}
              <span>{value}</span>
            </Fragment>
          ))}

          {!isEmpty(values) && !!suffix && ` ${suffix}`}
        </div>
      </div>
    </div>
  );
}

Item.propTypes = {
  description: PropTypes.string,
  icon: PropTypes.string,
  suffix: PropTypes.string,
  values: PropTypes.arrayOf(PropTypes.string),
};
